import script from "./ProxyConnDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyConnDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProxyConnDetails.vue?vue&type=style&index=0&id=696ab52b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-696ab52b"]])

export default __exports__